// Images attached to a prompt or a chat message (contract 2.7.0 proposal, ARTS_CONTRACT.md).
// Each one is an `art_image` asset of the profile with what the creator wants done with it;
// `auto` leaves it to the AI (it reads the prompt: "use as background", "like this one").
export const ATTACHMENT_LIMIT = 5;
export const ATTACHMENT_ROLES = ['auto', 'reference', 'background', 'photo', 'logo'];
export const ATTACHMENT_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
// A larger file is refused before it is read; what is uploaded is downscaled to 2400 px.
export const ATTACHMENT_MAX_BYTES = 30 * 1024 * 1024;

export const isAttachableFile = file => ATTACHMENT_TYPES.includes((file?.type || '').toLowerCase());
